import { useParams, useNavigate } from "react-router-dom";
import { useState } from "react";
import { Card } from "../../components/ui/card";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";
import { Badge } from "../../components/ui/badge";
import { ArrowLeft } from "lucide-react";

// Dummy BOUNTIES array for details (should match your main data source)
const BOUNTIES = [
  {
    id: 1,
    company: "Eigen Layer",
    title: "Design the new website for Eigen Layer",
    amount: "1200 USDC",
    dueTime: "1d 14h 13m",
    deliveryTime: "2 weeks",
    type: "Bounty",
    comments: 16,
    description: `Germany's Superteam is calling on all creative minds to design amazing merch! ...`,
    interested: 16,
    avatars: [
      "https://randomuser.me/api/portraits/men/32.jpg",
      "https://randomuser.me/api/portraits/women/44.jpg",
      "https://randomuser.me/api/portraits/men/45.jpg",
      "https://randomuser.me/api/portraits/women/46.jpg",
    ],
    prizes: [
      { label: "First Prize", amount: "800 USDC" },
      { label: "Second Prize", amount: "400 USDC" },
      { label: "Third Prize", amount: "200 USDC" },
    ],
    evolution: [
      { title: "Evolution Criteria", content: "Some criteria for evolution here." },
      { title: "Evolution Criteria", content: "Some more criteria for evolution here." },
    ],
  },
  // ...add the rest of your bounties here...
];

export default function SubmitBounty() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [github, setGithub] = useState("");
  const [remarks, setRemarks] = useState("");
  const [additional, setAdditional] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const bounty = BOUNTIES.find(b => b.id === Number(id));

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    // You can add API call here
  };

  return (
    <div>
      <div className="min-h-screen bg-[#FFF8F3] flex flex-col items-center py-12 px-4">
        {/* Back Button */}
        <div className="w-full max-w-2xl flex items-start mb-6">
          <Button
            variant="ghost"
            onClick={() => navigate(-1)}
            className="bg-white text-black shadow-md rounded-xl px-6 py-3 flex items-center hover:bg-gray-100 transition border border-black"
          >
            <ArrowLeft className="mr-2 h-5 w-5 text-black" />
            Back
          </Button>
        </div>
        {/* Bounty Details */}
        {bounty && (
          <div className="w-full max-w-2xl bg-[#FAF94F] border-2 border-black rounded-2xl shadow-[4px_6px_0px_#000] px-8 py-6 mb-8 flex flex-col gap-2">
            <div className="flex items-center gap-4 mb-2">
              <div className="w-12 h-12 bg-[#1602F2] rounded-full flex items-center justify-center">
                <span className="text-xl font-bold text-white">{bounty.company[0]}</span>
              </div>
              <div>
                <div className="flex items-center gap-2">
                  <h1 className="text-xl font-bold text-black">{bounty.title}</h1>
                  <Badge className="bg-green-600 text-white ml-2">Bounty</Badge>
                </div>
                <div className="text-[#888] text-sm font-medium mt-1">@{bounty.company.toLowerCase().replace(/ /g, '')}</div>
              </div>
            </div>
            <div className="text-black text-base leading-relaxed mb-2">
              {bounty.description.replace("...", "This is your opportunity to design exclusive t-shirts, stickers, and more that represent the essence of Superteam Germany and the Solana ecosystem. Some of the winning designs will get turned into physical merch!")}
            </div>
            <div className="flex gap-4 text-sm text-[#1602F2] font-bold">
              <span>Reward: <span className="bg-white border border-black rounded px-2 py-1 ml-1">{bounty.amount}</span></span>
              <span>Due: {bounty.dueTime}</span>
            </div>
          </div>
        )}
        {/* Submission Form */}
        <form onSubmit={handleSubmit} className="w-full max-w-2xl bg-white border-2 border-black rounded-2xl shadow-[4px_6px_0px_#000] px-8 py-8 flex flex-col gap-6">
          {submitted ? (
            <div className="text-green-600 font-semibold text-lg text-center">Submission received!</div>
          ) : (
            <>
              <div className="flex flex-col gap-2">
                <label className="font-bold uppercase text-xs text-[#888] tracking-widest mb-1">GitHub Link</label>
                <Input
                  type="url"
                  placeholder="https://github.com/your-repo"
                  value={github}
                  onChange={e => setGithub(e.target.value)}
                  required
                  className="border-2 border-black rounded-lg px-4 py-2 bg-[#FAF94F] shadow-[2px_2px_0px_#000] text-black font-semibold placeholder:text-[#888]"
                />
              </div>
              <div className="flex flex-col gap-2">
                <label className="font-bold uppercase text-xs text-[#888] tracking-widest mb-1">Remarks</label>
                <Input
                  type="text"
                  placeholder="Add your remarks..."
                  value={remarks}
                  onChange={e => setRemarks(e.target.value)}
                  className="border-2 border-black rounded-lg px-4 py-2 bg-[#FAF94F] shadow-[2px_2px_0px_#000] text-black font-semibold placeholder:text-[#888]"
                />
              </div>
              <div className="flex flex-col gap-2">
                <label className="font-bold uppercase text-xs text-[#888] tracking-widest mb-1">Additional Details</label>
                <textarea
                  placeholder="Add any additional details..."
                  value={additional}
                  onChange={e => setAdditional(e.target.value)}
                  className="border-2 border-black rounded-lg px-4 py-2 bg-[#FAF94F] shadow-[2px_2px_0px_#000] text-black font-semibold placeholder:text-[#888] min-h-[80px] resize-y"
                />
              </div>
              <Button type="submit" className="w-full h-12 border-2 border-black bg-[#FAF94F] text-black font-extrabold uppercase text-lg rounded-xl shadow-[4px_6px_0px_#000] hover:bg-[#f7e359] transition mt-2">Submit</Button>
            </>
          )}
        </form>
      </div>
    </div>
  );
} 